import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ValidationItem } from '../../shared/misc-classes';

@Component({
  selector: 'process-fail-dialog',
  templateUrl: 'process-fail-dialog.html',
  styleUrls: []
})
export class ProcessFailDialog {

  constructor(
    public dialogRef: MatDialogRef<ProcessFailDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ValidationItem) {
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

}